module.exports = __webpack_public_path__ + "img/user.87c47f29.svg";